import { GET_MEMBER_STATUS } from '../../constants/signin.js';

export const memberStatusMixin = {
    data () {
        return {
        };
    },
    methods: {
        GetLoginUserMemberStatus: async function () {
            var res = await this.$apollo.mutate({
                mutation: GET_MEMBER_STATUS,
                fetchPolicy: 'no-cache',
                variables: {
                    member_no: this.$store.state.auth.loginMember.member_no
                }
            });
                var memberStatusType = res.data.GetMemberStatus.member_status_type;
                if (memberStatusType == 9 || memberStatusType == 8) {
                    localStorage.removeItem('web-token');
                    this.$router.push('/');
                }
        },
    }
};
